import ReactDOM from 'react-dom/client';
import './index.css';
// The phone app shell's global rules; all of them sit under the phone breakpoint.
import './mobile/mobile-app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { initAmplitude } from './utils/amplitudeInit';
import { bootstrapAuthMode, isTransparentAuth } from './auth/authMode';
import { captureLinkSecrets, redirectTicketLanding } from './auth/linkSecrets';

// First of all: an e-mailed link carries a secret in the page address (invitation, password reset,
// one-time sign-in code). It is taken out of the address before anything can record it (analytics
// are started at mount) — see ./auth/linkSecrets. A no-op on every other address.
captureLinkSecrets();
// A link opened in a tab where the app is already running only changes the address: the secret is
// taken out just the same, and the page starts over — as it does when a link opens a new tab — so
// that the screen reads the new link and nothing of whoever used the tab before stays in memory.
// (Registered before the router and analytics exist: they only ever see the cleaned address.)
window.addEventListener('hashchange', () => {
  if (captureLinkSecrets()) window.location.reload();
});

function mount() {
  // Initialize Amplitude + Session Replay at boot so the entire session is recorded.
  initAmplitude();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <HashRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </HashRouter>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

// HOW people sign in: the API says whether this deployment redirects to Auth0 or runs the app's own
// screens (transparent authentication). Resolved before mount so the right provider is chosen from
// the first render. See ./auth/authMode.
bootstrapAuthMode('legacy').then(() => {
  // Transparent authentication: an invitation issued through Auth0 earlier is accepted on the
  // app's own screen — the page moves there instead of mounting on the ticket's address.
  if (isTransparentAuth() && redirectTicketLanding()) return;
  mount();
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      // no-op: service worker is optional
    });
  });
}
